var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Project Timeline Visualization")]),_c('Roadmap',{attrs:{"events":_vm.timelineData,"width":900,"height":600}}),_c('button',{on:{"click":_vm.addRandomEvent}},[_vm._v(_vm._s(_vm.$t('add-test-event')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }